import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    clientId: process.env.VUE_APP_CLIENT_ID,
    serverUrl: process.env.VUE_APP_MWS_URL,
    stripePublicKey: process.env.VUE_APP_STRIPE_KEY,
    publicUrl: [
      '/register',
      '/privacy-policy',
    ],
    isChildInterpreter: false as boolean,
  },
  mutations: {
    setChildInterpreter(state, isChild) {
      state.isChildInterpreter = isChild;
    },
  },
  actions: {
    setChildInterpreter({ commit }, isChild) {
      commit('setChildInterpreter', isChild);
    },
  },
});
